export class SaveRegistry {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._modules = [];
    }
    register(module) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._modules.push(module);
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getAll() {
        return [...this._modules];
    }
}
